/**
 * App-wide configuration. Swap these values when real links and assets are ready.
 */

export const SITE_NAME = 'ChemistFella';
export const SITE_DOMAIN = 'chemistfella.com';
export const SITE_URL = 'https://chemistfella.com';
export const SITE_TAGLINE = 'Virtual Chemistry Lab for Kids';

// Shown on the contact and privacy pages and in the site's structured data.
export const CONTACT_EMAIL = 'info@navigta.com';

// The company that makes and runs the site, named on the About and Contact pages, in the footer
// and in the structured data.
export const PUBLISHER_NAME = 'Navigta Ltd';
export const PUBLISHER_URL = 'https://navigta.com';

// Google AdSense publisher ID, like 'ca-pub-1234567890123456'. Leave empty until AdSense
// approves the site: while it's empty no ad code is loaded and no ads.txt is written.
export const ADSENSE_CLIENT_ID = 'ca-pub-8688616693434821';
// Ad unit IDs from the AdSense dashboard (Ads -> By ad unit). Empty ones are skipped.
export const ADSENSE_SLOTS = Object.freeze({
  PAGE_BOTTOM: '3590764716',
});
// Hidden while AdSense reviews the site, so no empty "Advertisement" box shows. The AdSense script in
// the <head> and public/ads.txt stay, because Google needs both for the review. Set to true once approved.
export const IS_AD_UNIT_VISIBLE = false;

// Payment link for the Support Us buttons.
export const DONATE_URL = 'https://buy.stripe.com/9B628s2JK8A1b21cnn4F200';

// Hidden until a payment provider approves the account. Set to true to show every Support Us button again.
export const IS_SUPPORT_BUTTON_VISIBLE = false;

export const ASSISTANT_NAME = 'Fizzy';

// Folder paths under /public. Drop real files with the same names into these folders.
export const GIF_BASE_PATH = `${process.env.PUBLIC_URL}/assets/gifs`;
export const SOUND_BASE_PATH = `${process.env.PUBLIC_URL}/assets/sounds`;

// Fizzy's pre-recorded voice clips and their manifest (made by `npm run voice:generate`).
export const VOICE_BASE_PATH = `${process.env.PUBLIC_URL}/assets/voice`;
export const VOICE_MANIFEST_FILE = 'manifest.json';

// How long the reaction animation plays before the assistant starts explaining (ms).
export const REACTION_ANIMATION_MS = 1800;

export const MAX_SELECTED_SUBSTANCES = 2;

// Remembers each visitor's "Read to me" choice between visits.
export const READ_ALOUD_STORAGE_KEY = 'chemistfella.readAloud';

/**
 * Fizzy's read-aloud voice, best first. Browsers only offer the voices installed on the
 * visitor's device, so we pick the most kid-like natural one available.
 * "Ana" is Microsoft's natural child voice (Edge on Windows/macOS/Android). The others are
 * natural adult voices raised in pitch so they sound younger.
 */
export const ASSISTANT_VOICE_PREFERENCES = Object.freeze([
  { namePattern: /\bAna\b.*Natural|Natural.*\bAna\b/i, pitch: 1.05, rate: 1 },
  { namePattern: /\bAna\b/i, pitch: 1.05, rate: 1 },
  { namePattern: /(Jenny|Aria|Emma|Michelle|Ava|Sonia|Libby|Maisie).*(Natural|Online)/i, pitch: 1.35, rate: 1.05 },
  { namePattern: /Google US English/i, pitch: 1.35, rate: 1.05 },
  { namePattern: /Google UK English Female/i, pitch: 1.35, rate: 1.05 },
  { namePattern: /Samantha|Karen|Moira|Tessa/i, pitch: 1.35, rate: 1.05 },
  { namePattern: /Zira|Hazel/i, pitch: 1.4, rate: 1.05 },
]);

// Real page addresses (not #/ links) so search engines can index every page.
export const ROUTES = Object.freeze({
  LAB: '/',
  ABOUT: '/about',
  ELEMENTS: '/elements',
  REACTIONS: '/reactions',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  CONTACT: '/contact',
  PARENTS: '/parents-and-teachers',
  WORKSHEETS: '/worksheets',
});
